import _classCallCheck from "/home/runner/work/mycarebase/mycarebase/front-end/react-native-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/home/runner/work/mycarebase/mycarebase/front-end/react-native-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/mycarebase/mycarebase/front-end/react-native-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/runner/work/mycarebase/mycarebase/front-end/react-native-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _wrapNativeSuper from "/home/runner/work/mycarebase/mycarebase/front-end/react-native-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";

/**
 * Created by sunny on 9/1/16.
 */
export var NotFoundError =
/*#__PURE__*/
function (_Error) {
  _inherits(NotFoundError, _Error);

  function NotFoundError(message) {
    var _this;

    _classCallCheck(this, NotFoundError);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NotFoundError).call(this, "Not Found! Params: ".concat(message)));
    _this.name = 'NotFoundError';
    _this.stack = new Error().stack; // Optional

    return _this;
  }

  return NotFoundError;
}(_wrapNativeSuper(Error)); // NotFoundError.prototype = Object.create(Error.prototype);

export var ExpiredError =
/*#__PURE__*/
function (_Error2) {
  _inherits(ExpiredError, _Error2);

  function ExpiredError(message) {
    var _this2;

    _classCallCheck(this, ExpiredError);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(ExpiredError).call(this, "Expired! Params: ".concat(message)));
    _this2.name = 'ExpiredError';
    _this2.stack = new Error().stack; // Optional

    return _this2;
  }

  return ExpiredError;
}(_wrapNativeSuper(Error)); // ExpiredError.prototype = Object.create(Error.prototype);